import React from "react";
import { Container, Navbar } from "react-bootstrap";

function PublicHeader() {
  return (
    <>
      <header className="header">
        <Navbar bg="primary" variant="dark" expand="lg" className="fixed-top p-0 shadow-sm ">
          <Container>
            <div className="col-md-4 col-sm-3"></div>
            <div className="col-md-4 col-sm-6">
              <div className="header__middle">
                <Navbar.Brand aria-label="logo" className="m-0">
                  <img
                    src={process.env.PUBLIC_URL + "/img/treesense-logo.webp"}
                    className="align-middle"
                    height="41"
                    width="90"
                    alt="Treesense Logo"
                  />
                </Navbar.Brand>
              </div>
            </div>
            <div className="col-md-4 col-sm-3"></div>
          </Container>
        </Navbar>
      </header>
    </>
  );
}

export default React.memo(PublicHeader);
